/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
//import {connect} from 'react-redux';
import { Link } from 'react-router-dom';

const FilterLink = ({ filter, children }) => ( 
  <Link 
    to={filter === 'SHOW_ALL' ? '/' : filter} 
    activeStyle={{ 
      textDecoration: 'none', 
      color: 'black'
    }}
  > 
    {children} 
  </Link>
);

export default FilterLink;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/todos/FilterLink.js